import { apiRootUrl } from 'sow/config';

export const API_URL = apiRootUrl;
